import { ImageLoaderProps } from 'next/image';

type PageWithSlug = {
  id: string;
  slug: string;
  parent: { id: string | null };
};

export const getStaticPathsFromPageSlugs = (
  pages: PageWithSlug[]
): { params: { slug: string[] } }[] => {
  const paths: { params: { slug: string[] } }[] = [];
  const map: { [key: string]: { slug: string; parentId: string | null } } = {};
  pages.forEach(({ id, slug, parent }) => {
    map[id] = { slug, parentId: parent?.id };
  });
  const getParent = (parentId: string | null) =>
    parentId ? map[parentId] : null;
  pages.forEach(({ parent, slug }) => {
    const slugs: string[] = [slug];
    let currentParent = getParent(parent?.id);
    while (currentParent) {
      slugs.unshift(currentParent.slug);
      currentParent = getParent(currentParent.parentId);
    }
    paths.push({ params: { slug: slugs } });
  });
  return paths;
};

export type PageWithSlugAndParent = {
  slug: string;
  parent?: PageWithSlugAndParent | null;
};

export const getPathFromPage = (page: PageWithSlugAndParent): string => {
  const { slug, parent } = page;
  const slugs: string[] = [slug];
  let currentParent = parent;
  while (currentParent) {
    slugs.unshift(currentParent.slug);
    currentParent = currentParent.parent;
  }
  return slugs.join('/');
};

export const hygraphImageLoader = ({
  src,
  width,
  quality,
}: ImageLoaderProps) => {
  const handle = src.split('/').slice(-1)[0];

  if (quality === 100) {
    return `https://media.graphassets.com/${handle}`;
  }

  return `https://media.graphassets.com/resize=w:${width},fit:crop/quality=value:${
    quality || 75
  }/output=format:webp/compress/${handle}`;
};

export const getSettledResponse = <T>(response: PromiseSettledResult<T>) => {
  if (response.status === 'fulfilled') {
    return response.value;
  }

  return {} as T;
};
